"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var lengthOfArrayLike = require("../internals/length-of-array-like");
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod("at", function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return k < 0 || k >= len ? void 0 : O[k];
});
